import React from 'react'
import Header from '../Integration/DashboardHeader'
import SideBarMenu from '../Integration/DashboardSideBarMenu'
import '../../Css/DashboardHome.css'
import SupplierDashboard from '../Integration/SupplierDashboard'



function Home() {
  return (
    <div>


      <div className="homeheader">
        <Header/>

      </div>

     <div className="homebody">



      <div className="homeleft">

      <SideBarMenu/>

      </div>
      <div className="homeright">

        <div className="upright">

       <SupplierDashboard/>
        </div>
        <div className="downright">


        </div>
        <div className='footageright'>


        </div>

      </div>
     </div>
        
    </div>
  )
}

export default Home